import { render, staticRenderFns } from "./transaction.vue?vue&type=template&id=2159257a&"
import script from "./transaction.vue?vue&type=script&lang=js&"
export * from "./transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2159257a')) {
      api.createRecord('2159257a', component.options)
    } else {
      api.reload('2159257a', component.options)
    }
    module.hot.accept("./transaction.vue?vue&type=template&id=2159257a&", function () {
      api.rerender('2159257a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/assets/transaction.vue"
export default component.exports